<template>
  <div v-if="isCustom">
    <slot />
  </div>
  <div
    v-else
    class="popup"
    ref="popup"
    :class="[popupStyleClass, { [popup]: !inPage }]"
    v-on:keydown.esc="!inPage ? closePopup() : $emit('popupToggle')"
  >
    <div class="popup__content">
      <slot v-if="inPage"></slot>
      <component v-else :is="popup"></component>
      <button
        v-if="popup !== 'PopupEmployeeWarning' && popup !== 'PopupOptionWarning' && close"
        @click.prevent="!inPage ? closePopup() : $emit('popupToggle')"
        class="popup__close"
        type="button"
      >
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path clip-rule="evenodd" d="M23.666 8.181a.55.55 0 10-.778-.777L15.5 14.793l-7.39-7.39a.55.55 0 00-.777.779l7.39 7.389-7.32 7.318a.55.55 0 10.779.778l7.318-7.318 7.319 7.318a.55.55 0 10.777-.778l-7.318-7.318 7.39-7.39z"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PopupAddNewEmployee from '@/elements/Popup/PopupAddNewEmployee';
import PopupTotalMarkup from '@/elements/Popup/PopupTotalMarkup';

export default {
  name: 'Popup',

  props: {
    inPage: {
      type: Boolean,
      default: false,
    },
    popup: {
      type: String,
      default: '',
    },
    close: {
      type: Boolean,
      default: true,
    },
    isCustom: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    popupStyleClass: '',
  }),

  components: {
    PopupLogin: () => import('./PopupLogin'),
    PopupBasket: () => import('./PopupBasket'),
    PopupCallback: () => import('./PopupCallback'),
    PopupCallCalculate: () => import('./PopupCallCalculate'),
    PopupGuide: () => import('./PopupGuide'),
    PopupAddCart: () => import('./PopupAddCart'),
    PopupThanks: () => import('./PopupThanks'),
    PopupSlider: () => import('./PopupSlider'),
    PopupEmployee: () => import('./employee/PopupEmployee'),
    PopupEmployeeView: () => import('./employee/PopupEmployeeView'),
    // TODO: больше не используется, можно потом удалить, но не сразу
    PopupPreview: () => import('./PopupPreview'),
    PopupModelAbout: () => import('./PopupModelAbout'),
    PopupClearCamera: () => import('./PopupClearCamera'),
    PopupError: () => import('./PopupError'),
    PopupSuccess: () => import('./PopupSuccess'),
    PopupOrderDetail: () => import('./order-detail/OrderDetail'),
    PopupNotification: () => import('./notifications/Notification'),
    PopupEditWarning: () => import('./PopupEditWarning'),
    PopupProfileBalance: () => import('./PopupProfileBalance'),
    PopupAccessAdd: () => import('./PopupAccess/PopupAccessAdd'),
    PopupEmployeeWarning: () => import('./PopupEmployeeWarning'),
    PopupOptionWarning: () => import('./PopupOptionWarning'),
    PopupZgiTenderWarning: () => import('./PopupZgiTenderWarning'),
    PopupCutTenderWarning: () => import('./PopupCutTenderWarning'),
    PopupReclamation: () => import('./reclamation/Reclamation'),
    PopupReclamationArchived: () => import('./reclamation/ReclamationArchived'),
    PopupReclamationChange: () => import('./reclamation/ReclamationChange'),
    PopupReclamationSearch: () => import('./reclamation/ReclamationSearch'),
    PopupWarehouseLeftovers: () => import('./warehouse/WarehouseLeftovers'),
    PopupDealerPrice: () => import('./warehouse/PopupDealerPrice'),
    PopupWarehouseProduction: () => import('./warehouse/WarehouseProduction'),
    PopupWarehouseWholesale: () => import('./warehouse/WarehouseWholesale'),
    PopupWarehouseDeleteCharge: () => import('./warehouse/WarehouseDeleteCharge'),
    PopupWarehousePrices: () => import('./warehouse/prices/Prices'),
    PopupOrderChangeStatus: () => import('./PopupOrderChangeStatus'),
    PopupTotalMarkup,
    PopupAddNewEmployee,
  },

  computed: {
    ...mapState({
      reclamation: state => state.account.reclamations.reclamation,
    }),
  },

  methods: {
    /*closePopup(e) {
      let el = this.$refs.popover;
      let target = e.target;
      if (target === el) {
        this.updatePopover(null, null);
      }
    },*/
    onEscapeKeyUp(event) {
      if (event.which === 27 && this.popup !== 'PopupEmployeeWarning') {
        !this.inPage ? this.updatePopup(null, null) : this.$emit('popupToggle');
      }
    },

    closePopup() {
      this.updatePopup(null, null);

      if (this.popup === 'PopupReclamationChange') {
        this.$router.replace({
          query: this.$route.query,
          hash: this.reclamation.uuid,
        });
        this.updatePopup(true, 'PopupReclamation');
      }
    },
  },

  created() {
    window.addEventListener('keyup', this.onEscapeKeyUp);
  },

  mounted() {
    // это нужно чтобы пофиксить везде баг с модалкой(title страницы заходит за модалку), чтобы не писать это каждый раз...
    this.$nextTick(() => {
      if (this.$el?.classList) {
        const classList = Object.values(this.$el.classList || {});
        const isPopupFixed = classList.find(item => item === 'popup--fixed');

        if (!isPopupFixed) {
          this.popupStyleClass = 'popup--fixed';
        }
      }
    });
  },

  beforeMount() {
    this.updatePopover(null, null);
    if (!this.isCustom) {
      document.body.classList.add('overflow');
    }
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.onEscapeKeyUp);

    if (!this.isCustom) {
      document.body.classList.remove('overflow');
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/style/blocks/popup.scss';
</style>
